export const base = {
    fontFamily: "Menlo, Inconcolata, Consolas",
    margin: '1em',
    fontSize: 11,
    color: 'rgb(66,66,66)',
    borderRadius:2
}

export const secondary = {
    color: 'rgb(210,210,210)'
}

export const highlight = {
    color: 'rgb(255,82,82)'
}



/** WEBPACK FOOTER **
 ** ./es2015/controls/styles.js
 **/